<template>
  <div>
    <div class="el-input">
      <el-input type="text" :value="val" style="text-align: right" maxlength="24" @input="change($event)" >
        <template slot="append">{{ append }}</template>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: '',
      append: null
    }
  },
  mounted () {
    if (this.config) {
      this.append = this.config[0]
    }
    if (this.value) {
      this.val = this.value
    }
  },
  props: ['value', 'config'],
  methods: {
    change: function (val) {
      this.val = val
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PublicInput.vue